export type QueryParams = Record<string, string | number | boolean | undefined>

/** Construye `?a=1&b=2`, omitiendo los valores `undefined`. */
export function buildQueryString(params: QueryParams): string {
  const search = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined) continue
    search.set(key, String(value))
  }
  const query = search.toString()
  return query ? `?${query}` : ''
}
